import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "feedback__form feedback checkout" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "notification__title" }, " Как только товар появится в наличии мы отправим Вам уведомление на электронную почту ", -1)
const _hoisted_3 = { class: "form-element notification__input" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: _normalizeClass({ feedback__error: _ctx.v$.email.$error }),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
        placeholder: "E-mail"
      }, null, 2), [
        [_vModelText, _ctx.email]
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "feedback__input-error notification__input-error",
        key: error.$uid
      }, _toDisplayString(error.$message), 1))
    }), 128)),
    _createElementVNode("button", {
      disabled: _ctx.loading,
      class: "feedback__btn basket__btn notification__btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendItem($event)))
    }, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Отправить"))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6))
        : _createCommentVNode("", true)
    ], 8, _hoisted_4)
  ]))
}